/**
 * IM 弹幕群/用户 API（118 方案 P4：由 Java 老后端迁移到 ai_mall_py）。
 *
 * 变更说明：
 * - im-group/im-user 的 REST 部分原走 Global.BASE_URL(8090)，现走 aiApiUtil
 *   通道（AI_BASE_URL 别名），路径不变；py 响应为 GlxVo 信封，统一解包取
 *   data，字段与 Java camelCase 逐字一致，
 *   消费方（useImUser / useSocketRef / LiveStore）零改动
 * - WS（imSocket）改连 py 的 /api/socket/im/{id}：走 AI_BASE_SOCKET（D17 动态
 *   推导 ws(s)://当前域名/ai-api，dev 经 vite ws 代理、生产 nginx 同路径 WS
 *   升级转发）；消息协议与
 *   Java 一致，进场通知 user_enter 前端已有分支
 * - user-sign/account 等 TIM 旧接口（注释态）保留不动
 */
import { glxGet, glxPost, glxPut } from './aiApiUtil';
import { AI_BASE_SOCKET } from './api-util';

export async function imJoinGroup({ imGroupId, imUserId }) {
    return glxPut('/im-group/join', {
        data: {
            imGroupId,
            imUserId
        }
    })
}

export async function imQuitGroup({ imGroupId, imUserId }) {
    return glxPut('/im-group/quit', {
        data: {
            imGroupId,
            imUserId
        }
    })
}

export async function imGroupInfo({ id }) {
    return glxGet(`/im-group/${id}`)
}

export async function imUserList({ groupId }) {
    return glxGet('/im-user', {
        params: {
            groupId
        }
    })
}

export async function imUserInfo({ imUserId }) {
    return glxGet(`/im-user/${imUserId}`)
}

export async function addImUser() {
    return glxPost('/im-user', {
        data: {}
    })
}

export async function modifyImUser({ imUserId, userId, nickname, avatar, gender }) {
    return glxPut(`/im-user/${imUserId}`, {
        data: {
            userId,
            nickname,
            avatar,
            gender
        }
    })
}

// 118 方案：IM 弹幕 WS 改连 ai_mall_py（D17 动态推导：ws(s)://当前域名/ai-api，
// dev 经 vite ws 代理、生产经 nginx 同路径 WS 升级转发到 py）
export const imSocket = ({ imUserId }) => {
    return `${AI_BASE_SOCKET}/api/socket/im/${imUserId}`
}

/*
export async function imUserSign({userId}) {
    return http({
        method: Method.GET,
        url: Global.BASE_URL + `/api/im/user-sign`,
        params: {
            userId
        }
    }).then(res => res.data)
}

export async function imDeleteAccount({userId}) {
    return http({
        method: Method.DELETE,
        url: Global.BASE_URL + `/api/im/account/${userId}`
    })
}*/
